import { provideZoneChangeDetection } from '@angular/core';
/// <reference types="@angular/localize" />

import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { handleChunkLoadError } from './app/core/utils/chunk-load-recovery.util';

globalThis.addEventListener('unhandledrejection', (event) => {
  if (handleChunkLoadError(event.reason)) {
    event.preventDefault();
  }
});

bootstrapApplication(AppComponent, {
  ...appConfig,
  providers: [provideZoneChangeDetection(), ...appConfig.providers],
}).catch((err) => console.error(err));
